import { render, staticRenderFns } from "./Organize.vue?vue&type=template&id=9c644f3e&"
import script from "./Organize.vue?vue&type=script&lang=js&"
export * from "./Organize.vue?vue&type=script&lang=js&"
import style0 from "./Organize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports